import { assertEnabledAPI } from './assertEnabledAPI';
export class EssentialsPartialGetters {
    getExperiments(fallback) {
        var _a;
        const experiments = (_a = this.experiments) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.experiments;
        assertEnabledAPI(experiments, 'Experiments were used without being correctly initialized! Make sure you pass `{ experiments: { scopes: [...] } }` to the `createEssentials` function.');
        return experiments;
    }
    getFedopsLogger(fallback) {
        var _a;
        const fedopsLogger = (_a = this.fedopsLogger) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.fedopsLogger;
        assertEnabledAPI(fedopsLogger, "Fedops was used without being correctly initialized! Make sure you pass`{ fedops: { appName: '...' } }` to the `createEssentials` function.");
        return fedopsLogger;
    }
    getErrorMonitor(fallback) {
        var _a;
        const errorMonitor = (_a = this.errorMonitor) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.errorMonitor;
        assertEnabledAPI(errorMonitor, 'ErrorMonitor was used without being correctly initialized! Make sure you pass `{ errorMonitor: { ... } }` to the `createEssentials` function.');
        return errorMonitor;
    }
    getI18n(fallback) {
        var _a;
        const _i18n = (_a = this.i18n) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.i18n;
        assertEnabledAPI(_i18n, 'i18n was used without being correctly initialized! Make sure you pass `{ i18n: { ... } }` to the `createEssentials` function.');
        return _i18n;
    }
    getBILoggerFactory(fallback) {
        var _a;
        const biLoggerFactory = (_a = this.biLoggerFactory) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.biLoggerFactory;
        assertEnabledAPI(biLoggerFactory, 'BILoggerFactory was not initialized');
        return biLoggerFactory;
    }
    getBILogger(fallback) {
        var _a;
        const biLogger = (_a = this.biLogger) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.biLogger;
        assertEnabledAPI(biLogger, 'BILogger was not initialized');
        return biLogger;
    }
    getHttpClient(fallback) {
        var _a;
        const httpClient = (_a = this.httpClient) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.httpClient;
        assertEnabledAPI(httpClient, 'HttpClient was not initialized');
        return httpClient;
    }
    getEnvironment(fallback) {
        const environment = fallback === null || fallback === void 0 ? void 0 : fallback.environment;
        assertEnabledAPI(environment, 'Environment was not initialized');
        return environment;
    }
    getDataCapsule(fallback) {
        var _a;
        const dataCapsule = (_a = this.dataCapsule) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.dataCapsule;
        assertEnabledAPI(dataCapsule, 'DataCapsule was used without being correctly initialized! Make sure you pass `{ dataCapsule: { ... } }` to the `createEssentials` function.');
        return dataCapsule;
    }
    getCreateCurrencyFormatter(fallback) {
        var _a;
        const createCurrencyFormatter = (_a = this.createCurrencyFormatter) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.createCurrencyFormatter;
        assertEnabledAPI(createCurrencyFormatter, 'CreateCurrencyFormatter was not initialized');
        return createCurrencyFormatter;
    }
    getFormatAddress(fallback) {
        var _a;
        const formatAddress = (_a = this.formatAddress) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.formatAddress;
        assertEnabledAPI(formatAddress, 'formatAddress was not initialized');
        return formatAddress;
    }
    getPanoramaClient(fallback) {
        var _a;
        const panoramaClient = (_a = this.panoramaClient) !== null && _a !== void 0 ? _a : fallback === null || fallback === void 0 ? void 0 : fallback.panoramaClient;
        assertEnabledAPI(panoramaClient, 'panoramaClient was not initialized');
        return panoramaClient;
    }
}
//# sourceMappingURL=EssentialsPartialGetters.js.map